import api from "../../../services/axiosConfig";
export const fetchDashboards = async () => {
  try {
    const response = await api.get("/instances/skeye/skeyechart/dashboards", {
      data: {},
    });
    return response.data.data.dashboards;
  } catch (error) {
    console.error("Error fetching dashboard:", error);
    throw error;
  }
};
